import API from "../../../../../global/api";
import jsPDF from "jspdf";
import { PDFHeader } from "../../../../../global/globalFunctions";


export const requestHybridAndCompleteData = () => {
  return {
    type: "REQUEST_HYBRID_AND_COMPLETE_DATA",
  };
};
export const successHybridAndCompleteData = (data) => {
  return {
    type: "SUCCESS_HYBRID_AND_COMPLETE_DATA",
    payload: data,
  };
};
export const errorHybridAndCompleteData = () => {
  return {
    type: "ERROR_HYBRID_AND_COMPLETE_DATA",
  };
};
export const getHybridAndCompleteData = () => {
  return (dispatch) => {
    dispatch(requestHybridAndCompleteData());
    API.get(`/products/ledger_products`)
      .then((res) => {
        let getData = res.data;
        dispatch(successHybridAndCompleteData(getData));
      }).catch((error) => {
        dispatch(errorHybridAndCompleteData());
      });
  };
};


export const requestSearchInventoryLedgerReport = () => {
  return {
    type: "REQUEST_SEARCH_INVENTORY_REPORT",
  };
};
export const successSearchInventoryLedgerReport = (data) => {
  return {
    type: "SUCCESS_SEARCH_INVENTORY_REPORT",
    payload: data,
  };
};
export const errorSearchInventoryLedgerReport = () => {
  return {
    type: "ERROR_SEARCH_INVENTORY_REPORT",
  };
};
export const searchInventoryLedgerReport = (data, startDate, endDate) => {
  return (dispatch) => {
    console.log(data, "data");
    dispatch(requestSearchInventoryLedgerReport());
    API.post(`/products/inventory_ledger`, data)
      .then((res) => {
        let getData = res.data;
        const unit = "pt";
        const size = "A4";
        const orientation = "p";
        const doc = new jsPDF(orientation, unit, size);
        PDFHeader(doc, "Inventory Ledger");

        doc.text(`Date From: ${startDate} - Date To: ${endDate}`, 50, 130, 0, 20);

        const headers = [
          [
            "DATE",
            "Add Quantity",
            "Less Quantity",
            "Total Quantity",
            "OPENING BALANCE",
          ],
        ];
        const data = getData.data.map((x) => [
          x.transactionDate,
          x.addQuantity,
          x.lessQuantity,
          x.closingBalance,
          x.openingBalance,
        ]);
        let content = {
          startY: 150,
          startX: 10,
          head: headers,
          body: data,
        };
        doc.autoTable(content);

        doc.setProperties(`Inventory Ledger Print`);
        var blob = doc.output("blob");
        window.open(URL.createObjectURL(blob));

        dispatch(successSearchInventoryLedgerReport(getData));
      }).catch((error) => {
        dispatch(errorSearchInventoryLedgerReport());
      });
  };
};


export const requestSearchInventoryLedger = () => {
  return {
    type: "REQUEST_SEARCH_INVENTORY",
  };
};
export const successSearchInventoryLedger = (data) => {
  return {
    type: "SUCCESS_SEARCH_INVENTORY",
    payload: data,
  };
};
export const errorSearchInventoryLedger = () => {
  return {
    type: "ERROR_SEARCH_INVENTORY",
  };
};
export const searchInventoryLedger = (data, startDate, endDate) => {
  return (dispatch) => {
    dispatch(requestSearchInventoryLedger());
    API.post(`/products/inventory_ledger`, data)
      .then((res) => {
        let getData = res.data;
        dispatch(successSearchInventoryLedger(getData));
      }).catch((error) => {
        dispatch(errorSearchInventoryLedger());
      });
  };
};